import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { EstadoService } from './shared/estado.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TipoEstadoService } from './shared/tipo-estado.service';
import { Estado } from './shared/estado.model';
import { TipoEstado } from './shared/tipo-estado.model';
import 'datatables.net';
import 'datatables.net-bs4';
import * as $ from 'jquery';

@Component({
  selector: 'app-estados',
  templateUrl: './estados.component.html',
  styleUrls: ['./estados.component.css']
})
export class EstadosComponent implements OnInit {
  formEstado:FormGroup;
  formTipoEstado:FormGroup;
  frameState:boolean;
  edit:boolean;

  datatable: any;

  ListEstados: TipoEstado[] = [];
  ListEstadosByTipo: Estado[] = [];

  constructor(
    private estadoService:EstadoService,
    private tipoEstadoService:TipoEstadoService,
    private toastr:ToastrService,
    private _fb:FormBuilder,
    private chRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    //this.refeshList();
    this.formIni();
  }

  formIni(){

    this.getEstados();

    this.formTipoEstado = this._fb.group({
      idAdmTipoEstado:[0,Validators.required],
      nombre:["",Validators.required]
    });

    this.formEstado = this._fb.group({
      idAdmEstado:[],
      idAdmTipoEstado:[],
      nombre:[],
      descripcion:[],
      activo:[],
    });
  }

  resetFormTipo(){
    this.formTipoEstado.reset();
  }

  resetFormEstado(){
    this.formEstado.reset();
  }

  getEstados(){
    this.tipoEstadoService.getEstado().then(r => {
      
      if ($.fn.dataTable.isDataTable('#datatableInfEst')) {
        this.datatable.destroy();
      }

      this.ListEstados = r as TipoEstado[];
      
      this.chRef.detectChanges();

        const table: any = $('#datatableInfEst');
        this.datatable = table.DataTable({
          responsive: true
        })

    });
  }

  refeshList(){
    this.tipoEstadoService.getEstado();
  }

  refreshListEstadoByIdTipo(id:number){
    this.estadoService.getEstadoByIdTipoEstado(id);
  }

  update(){
    this.tipoEstadoService.putEstado(this.formTipoEstado.value,this.formTipoEstado.get("idAdmTipoEstado").value).then(r=>{this.toastr.success("Actualizado correctamente");this.getEstados()})
    this.formTipoEstado.patchValue({nombre:''});//TODO: se deben validar los mensajes que seran retornados.
  }

  getEstadoById(id:number){
    this.toastr.warning("Aun no implementado")
  }

  onSubmit(){
    this.update();
  }

  editar(nombre:string,id:number){
    this.frameState = false;
    this.formTipoEstado.patchValue({
      idAdmTipoEstado:id,
      nombre:nombre
    });
  }

  editarEstado(nombre:string,idAdmEstado:number){
    this.edit = true;
    this.formEstado.patchValue({
      idAdmEstado:idAdmEstado,
      idAdmTipoEstado:this.tipoEstadoService.tipoEstado.idAdmTipoEstado,
      nombre:nombre,
      descripcion:null,
      activo:true,
    });
  }

  listEstado(id:number){
    this.frameState = true;
    let tipoE = new TipoEstado();
    tipoE.idAdmTipoEstado = id;
    this.tipoEstadoService.tipoEstado = tipoE;
    this.getListEstadoByTipo(id);
    //this.refreshListEstadoByIdTipo(id);
  }

  getListEstadoByTipo(id: number){
    this.estadoService.getEstadoByIdTipoEstado(id).then(r => {
      
      if ($.fn.dataTable.isDataTable('#datatableEst')) {
        this.datatable.destroy();
      }

      this.ListEstadosByTipo = r as Estado[];
      
      this.chRef.detectChanges();

        const table: any = $('#datatableEst');
        this.datatable = table.DataTable({
          responsive: true
        })

    });
  }

  cancelState(){
    this.frameState = false;
    this.resetFormEstado();
    this.resetFormTipo();
    this.getEstados();
  }

  delete(id:number){
    this.toastr.error("Deletado papu")
  }

  deleteEstado(id:number){
    this.toastr.error("Deletado papu")
  }

  onSubmitState(){
    this.estadoService.postEstado(this.formEstado.value).then(r=>{this.toastr.success("Exito")});
    //TODO: Validar los mensajes que seran retornados en la respuesta.
  }

  submitUpdate(){
    this.updateState();    
  }

  updateState(){
    this.estadoService.putEstado(this.formEstado.value,this.formEstado.get("idAdmEstado").value).then(r=>{this.toastr.success("Actualizado correctamente");this.getListEstadoByTipo(this.formEstado.get("idAdmTipoEstado").value)});
    this.edit = false;
    this.formEstado.patchValue({nombre:''});
    //TODO:Realizar los cambios necesarios en la respuesta del programa.
  }
}
